import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import React, { useState, useContext } from "react";
import { ViewContext } from "./contexts/ViewContext";

export default function ObstacleReport() {
    const { view, dispatch } = useContext(ViewContext);

    const [accessibility, setAccessibility] = useState(null);
    const [permanence, setPermanence] = useState(null);
    const [photo, setPhoto] = useState(null);

    const handleSubmitPhoto = (photo) => {
        setPhoto(URL.createObjectURL(photo));
    };
    const handleObstacleSubmit = () => {
        dispatch({ type: "CHANGE PAGE", pageType: "poi", direction: 1 });
    };

    return (
        <div>
            <div style={{ width: "100%" }}>
                {photo ? (
                    <img
                        src={photo}
                        alt="obstacle"
                        style={{
                            width: "250px",
                            margin: "0 auto",
                            display: "block",
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "250px",
                            margin: "0 auto",
                            display: "block",
                            height: "167px",
                            backgroundColor: "#eeeeee",
                        }}
                    >
                        <input
                            accept="image/*"
                            style={{ display: "none" }}
                            id="img-upload"
                            type="file"
                            onChange={(evt) =>
                                handleSubmitPhoto(evt.target.files[0])
                            }
                        />
                        <label htmlFor="img-upload">
                            <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="span"
                                style={{
                                    zIndex: 9999,
                                    position:
                                        "absolute" /*Can also be `fixed`*/,
                                    left: "150px",
                                    top: "125px",
                                }}
                            >
                                <PhotoCamera fontSize="large" />
                            </IconButton>
                        </label>
                    </div>
                )}
            </div>

            <FormControl component="fieldset" style={{ marginTop: "12px" }}>
                <FormLabel component="legend">
                    {view.locale === "hu"
                        ? "mennyire nehéz az átjutás"
                        : view.locale === "en" &&
                          "How difficult it is to pass the obstacle?"}
                </FormLabel>
                <RadioGroup
                    aria-label="accessibility"
                    name="controlled-radio-buttons-group"
                    value={accessibility}
                    onChange={(evt) => setAccessibility(evt.target.value)}
                >
                    <FormControlLabel
                        value="UNCOMFORTABLE"
                        control={<Radio />}
                        label={
                            view.locale === "hu"
                                ? "Kényelmetlen"
                                : view.locale === "en" && "Uncomfortable"
                        }
                    />
                    <FormControlLabel
                        value="LIMITED"
                        control={<Radio />}
                        label={
                            view.locale === "hu"
                                ? "Segítséggel"
                                : view.locale === "en" && "Assistance needed"
                        }
                    />
                    <FormControlLabel
                        value="BLOCKED"
                        control={<Radio />}
                        label={
                            view.locale === "hu"
                                ? "Nem járható"
                                : view.locale === "en" && "Not accessible"
                        }
                    />
                </RadioGroup>
            </FormControl>
            <FormControl component="fieldset" style={{ marginTop: "12px" }}>
                <FormLabel component="legend" style={{ marginBottom: "6px" }}>
                    {view.locale === "hu"
                        ? "Várhatóan mennyi ideig lesz ott az akadály?"
                        : view.locale === "en" &&
                          "How long will the obstacle be there?"}
                </FormLabel>
                <RadioGroup
                    aria-label="permanence"
                    name="controlled-radio-buttons-group"
                    value={permanence}
                    onChange={(evt) => setPermanence(evt.target.value)}
                >
                    <FormControlLabel
                        value="hours"
                        control={<Radio />}
                        label={
                            <>
                                <Typography variant="body2">
                                    {view.locale === "hu"
                                        ? "Órákig"
                                        : view.locale === "en" && "For hours"}
                                </Typography>
                                <Typography variant="caption">
                                    {view.locale === "hu"
                                        ? "pl. járdán parkoló autó"
                                        : view.locale === "en" &&
                                          "e.g. illegal parking"}
                                </Typography>
                            </>
                        }
                    />
                    <FormControlLabel
                        value="days"
                        control={<Radio />}
                        label={
                            <>
                                <Typography variant="body2">
                                    {" "}
                                    {view.locale === "hu"
                                        ? "Napokig"
                                        : view.locale === "en" && "For days"}
                                </Typography>
                                <Typography variant="caption">
                                    {view.locale === "hu"
                                        ? "pl. útfelbontás, állványozás"
                                        : view.locale === "en" &&
                                          "e.g. road construction, scaffolding"}
                                </Typography>
                            </>
                        }
                    />
                    <FormControlLabel
                        value="permanent"
                        control={<Radio />}
                        label={
                            <>
                                <Typography variant="body2">
                                    {" "}
                                    {view.locale === "hu"
                                        ? "Tartósan"
                                        : view.locale === "en" && "Permanently"}
                                </Typography>
                                <Typography variant="caption">
                                    {view.locale === "hu"
                                        ? "pl. lámpaoszlop, lépcső"
                                        : view.locale === "en" &&
                                          "e.g. lamppost, steps"}
                                </Typography>
                            </>
                        }
                    />
                </RadioGroup>
            </FormControl>
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
                style={{ marginTop: "16px" }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleObstacleSubmit()}
                >
                    {view.locale === "hu"
                        ? "Akadály beküldése"
                        : view.locale === "en" && "Report obstacle"}
                </Button>
            </Grid>
        </div>
    );
}
